<template>
    <div id="pageTable">
        <v-container 
            class="d-flex align-center justify-center" 
            style="height: 80vh; width: 80vw;"
            v-if="rol == 'empleado' || rol == 'admin-depto'"
        >
			<v-card class="" style="border-radius:20px" max-width="500">
                <v-card-title class="justify-center card_titulo">
                    <div class="headerModal">
                        <img :src="'/static/icon/peligro.svg'" class="imgModal"/>
                    </div>
                </v-card-title>
                <v-card-text class="titleModal text-center">
                    Esta vista no esta disponible para este rol de usuario.
                </v-card-text>
                <v-card-actions class="d-flex align-center justify-center card_accion">
                    <v-btn
                        class="btnGuardar"
                        @click="redireccionar()"
                    >
                        Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
		</v-container>
        <v-container v-else  grid-list-xl fluid>
            <v-row>
                <v-col lg="12">
                    <data-table 
                        ref="tableGuisos"
                        :tableName="'Menú de las cocinas'"
                        :url="url"
                        :columns="columns"
                        :filters="filters"
                        :perPage="[10, 25, 50, 100]"
                        @loadModalData="loadModalData"
                        @setFilters="setFilters"
                        :showAdvancedFilters="true">
                        <template slot="actionButtonsLeft">
                            <div class="botonAgregar pr-3">
                                <v-btn
                                    rounded
                                    color="#004BAF"
                                    class="btnAdd"
                                    right
                                    @click="abrirModal('add')">
                                    <v-icon dark class="mr-2">add</v-icon>Agregar
                                    <div class="mr-4"></div>
                                </v-btn>
                            </div>
                        </template>
                        <template slot="actionButtonsLeft">
                            <v-menu offset-y content-class="menuClassAcciones">
                                <template v-slot:activator="{on,attrs}">
                                    <v-btn class="btnAcciones pr-1 mr-3"
                                        v-bind="attrs"
                                        dark
                                       v-on="on"
                                        elevation="0">
                                        Acciones
                                        <template v-for="(item,valor) in attrs">
                                            <v-icon :key="valor" v-if="valor == 'aria-expanded' && item == 'true'" class="pl-2" color="#FFFFFF">expand_less</v-icon>
                                            <v-icon :key="valor" v-if="valor == 'aria-expanded' && item == 'false'" class="pl-2" color="#FFFFFF">expand_more</v-icon>
                                        </template>
                                    </v-btn>
                                </template>
                                <div class="btnAccionesContenedor">
                                    <div @click="modalLayout('importar')" class="btnAccionesItem py-2">
                                        <span>Importar layout de platillos</span>
                                    </div>
                                    <!-- <div v-if="rol == 'admin-sucursal'" @click="descargarLayout()" class="btnAccionesItem py-2">
                                        <span>Descargar layout de platillos</span><br />
                                    </div>
                                    <div v-else @click="modalLayout('exportar')" class="btnAccionesItem py-2">
                                        <span>Descargar layout de platillos</span><br />
                                    </div> -->
                                    <div @click="(rol == 'root' || rol =='admin') ? modalLayout('exportar'):descargarLayout()" class="btnAccionesItem py-2">
                                        <span>Descargar layout de platillos</span><br />
                                    </div>
                                </div>
                            </v-menu>
                        </template>
                        <template slot="filters">
                            <v-row>
                                <v-col v-if="rol === 'root'"  cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                    <v-autocomplete
                                        :items="clientes"
                                        item-text="nombre"
                                        item-value="id"
                                        label="Cliente"
                                        outlined
                                        v-model="cliente_id"></v-autocomplete>
                                </v-col>
                                <v-col v-if="rol==='root' || rol ==='admin'"  cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                    <v-autocomplete
                                        :items="empresas"
                                        item-text="nombre"
                                        item-value="id"
                                        v-model="empresa_id"
                                        label="Empresa"
                                        outlined></v-autocomplete>
                                </v-col>
                                <v-col cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                    <v-autocomplete
                                        :items="cocinas"
                                        item-text="nombre"
                                        item-value="id"
                                        v-model="cocina_id"
                                        label="Cocina"
                                        outlined></v-autocomplete>
                                </v-col>
                                <v-col cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                    <v-select
                                        :items="filtroTipoArr"
                                        v-model="filtroTipo"
                                        label="Tipo"
                                        outlined></v-select>
                                </v-col>
                                <v-col cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                    <date-picker
                                        outlined
                                        label="Fecha Mínima"
                                        :valorDefecto="filters.fecha_min"
                                        v-model="filters.fecha_min"
                                        placeholder="dd/mm/aaaa"
                                        ref="FechaMin"></date-picker>
                                </v-col>
                                <v-col cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                    <date-picker
                                        outlined
                                        label="Fecha Máxima"
                                        :valorDefecto="filters.fecha_max"
                                        v-model="filters.fecha_max"
                                        placeholder="dd/mm/aaaa"
                                        ref="FechaMax"></date-picker>
                                </v-col>
                                <v-col cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                    <v-text-field
                                        outlined
                                        label="Nombre guiso"
                                        v-model="nombre_guiso"></v-text-field>
                                </v-col>
                            </v-row>
                        </template>
                        <tbody slot="body" slot-scope="{data}">
                            <tr :key="item.id" v-for="item in data">
                                <td>
                                    <div class="tblPrincipal">{{ item.nombre }}</div>
                                </td>
                                <td>
                                    <div class="tblPrincipal">{{ item.cocina.nombre }}</div>
                                </td>
                                <td>
                                    <div class="tblPrincipal">{{ !item.fecha ? 'NA' : dateFormat(item.fecha) }}</div>
                                </td>
                                <td>
                                    <div class="tblPrincipal text-capitalize">{{ item.tipo }}</div>
                                </td>
                                <td>
                                    <div class="tblOpciones">
                                        <v-menu 
                                        buttom
                                        left
                                        content-class="menuClassAcciones mt-0"                                         
                                        >
                                            <template v-slot:activator="{on,attrs}">
                                                <v-btn class="botonHover"
                                                    v-bind="attrs"
                                                    dark
                                                    fab
                                                    small
                                                    icon
                                                    v-on="on"
                                                    >
                                                    <v-icon class="tamIconoBoton iconoDelgadoBoton">mdi-dots-vertical</v-icon>
                                                </v-btn>
                                            </template>
                                            <div class="btnAccionesContenedor" style="width: auto;">
                                                <div @click="abrirModal('update',item)" class="btnAccionesItem py-2">
                                                    <span>Editar</span>
                                                </div>
                                                <div @click="eliminarGuiso(item.id)" class="btnAccionesItem py-2">
                                                    <span>Eliminar</span><br />
                                                </div>
                                                <div 
                                                @click="abrirModal('duplicar',item)" 
                                                class="btnAccionesItem py-2"
                                                v-if="item.tipo == 'diario'">
                                                    <span>Duplicar</span><br />
                                                </div>
                                            </div>
                                        </v-menu>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </data-table>
                </v-col>
            </v-row>
        </v-container>

        <!-- ** Modal layout-->
        <template>
            <v-dialog v-model="modal_layout" persistent max-width="600">
                <v-card elevation="0">
                    <ValidationObserver ref="formLayout" v-slot="{invalid}">
                        <v-card-title class="card_titulo">
                            <div class="headerModal">
                                <h2 class="ml-4">{{ titulo_modalLayout }}</h2>
                            </div>
                        </v-card-title>
                        <v-card-text class="card_texto">
                            <v-container grid-list-md id="contenedor">
                                <v-divider class="divider"></v-divider>
                                <v-row>
                                    <v-col v-if="rol === 'root'" cols="12" xs="12" md="12" lg="12" xl="12" class="py-0">
                                    <ValidationProvider v-slot="{errors}" name="Cliente" rules="required">
                                        <v-autocomplete
                                            outlined
                                            label="Cliente"
                                            :items="clientes"
                                            item-text="nombre"
                                            item-value="id"
                                            v-model="cliente_id"
                                            required
                                            :error-messages="errors">
                                        </v-autocomplete>
                                    </ValidationProvider>
                                </v-col>
                                <v-col v-if="rol === 'root' || rol == 'admin'" cols="12" xs="12" md="12" lg="12" xl="12" class="py-0">
                                    <ValidationProvider v-slot="{errors}" name="Empresa" rules="required">
                                        <v-autocomplete
                                            outlined
                                            label="Empresa"
                                            :items="empresas"
                                            item-text="nombre"
                                            item-value="id"
                                            v-model="empresa_id"
                                            required
                                            :error-messages="errors">
                                        </v-autocomplete>
                                    </ValidationProvider>
                                </v-col>
                                <v-col v-if="acccion_layout === 'importar'" cols="12" xs="12" md="12" lg="12" xl="12" class="py-0">
                                    <ValidationProvider v-slot="{errors}" name="Layout" rules="required">
                                        <v-file-input
                                            outlined
                                            label="Seleccione el archivo"
                                            v-model="archivo_layout"
                                            required
                                            prepend-icon=""
                                            accept=".xlsx"
                                            append-icon="attach_file"
                                            id="fileDocument"
                                            @click:append="open"
                                            :error-messages="errors">
                                        </v-file-input>
                                    </ValidationProvider>
                                </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions class="d-flex justify-end card_accion">
                            <v-btn class="btnCerrar elevation-0" @click="cerrar()" :disabled="loading_guardar">Cancelar</v-btn>
                            <v-btn class="btnGuardar elevation-0" @click="layoutGuiso()" :loading="loading_guardar" :disabled="invalid">{{ acccion_layout == 'importar' ? 'Importar':'Descargar' }}</v-btn>
                        </v-card-actions>
                    </ValidationObserver>
                </v-card>
            </v-dialog>
        </template>

        <!--**Modal para duplicar guiso-->
        <template>
            <v-dialog v-model="modal_replica" persistent max-width="500px">
                <template v-slot:activator="{on}">
                    <v-btn v-on="on" class="botonModal" id="btnModal"></v-btn>
                </template>
                <v-card elevation="0">
                    <ValidationObserver ref="formReplica" v-slot="{invalid}">
                        <v-card-title class="card_titulo">
                            <div class="headerModal">
                                <h2 class=" ml-4">{{ titulo_modal }}</h2>
                            </div>
                        </v-card-title>
                        <v-card-text class="card_texto">
                            <v-container grid-list-md id="contenedor">
                                <v-divider class="divider"></v-divider>
                                <v-row>
                                    <v-col cols="12" xs="12" md="12" lg="12" xl="12" class="py-0">
                                            <date-picker
                                                outlined
                                                rules="required"
                                                label="Fecha"
                                                :valorDefecto="replica.fecha"
                                                v-model="replica.fecha"
                                                placeholder="dd/mm/aaaa"
                                                ref="FechaReplica"></date-picker>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions class="d-flex justify-end card_accion">
                                <v-btn class="btnCerrar elevation-0" @click="cerrar()" :disabled="loading_guardar">Cancelar</v-btn>
                                <v-btn class="btnGuardar elevation-0" @click="duplicarGuiso()" :loading="loading_guardar" :disabled="invalid">Duplicar</v-btn>
                            </v-card-actions>
                    </ValidationObserver>
                </v-card>
            </v-dialog>
        </template>
        <!-- ** Modal de registro y edición-->
        <template>
            <v-dialog v-model="modal" persistent max-width="700px" scrollable>
                <template v-slot:activator="{on}">
                    <v-btn v-on="on" class="botonModal" id="btnModal"></v-btn>
                </template>
                <perfect-scrollbar style="background: #FFF;">
                    <v-card elevation="0">
                        <ValidationObserver ref="form" v-slot="{invalid}">
                            <v-card-title class="card_titulo">
                                <div class="headerModal">
                                    <!-- <img :src="imagen" alt="imgModal">
                                    <h2 class="titleModal">{{ titulo_modal }}</h2> --> 
                                    <h2 class="mb-10 ml-4">{{ titulo_modal }}</h2>
                                </div> 
                            </v-card-title>
                            <v-card-text class="card_texto">
                                <v-container grid-list-md id="contenedor">
                                    <!-- <v-divider class="divider"></v-divider> -->
                                    <v-row>
                                        <template v-if="accion ==='add'">
                                            <v-col v-if="rol === 'root'" cols="12" xs="12" md="12" lg="12" xl="12" class="py-0">
                                                <ValidationProvider v-slot="{errors}" name="Cliente" rules="required">
                                                    <v-autocomplete
                                                        outlined
                                                        label="Cliente"
                                                        :items="clientes"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        v-model="cliente_id"
                                                        required
                                                        :error-messages="errors">
                                                    </v-autocomplete>
                                                </ValidationProvider>
                                            </v-col>
                                            <v-col v-if="rol === 'root' || rol === 'admin'" cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                                <ValidationProvider v-slot="{errors}" name="Empresa" rules="required">
                                                    <v-autocomplete
                                                        outlined
                                                        label="Empresa"
                                                        :items="empresas"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        v-model="empresa_id"
                                                        required
                                                        :error-messages="errors"></v-autocomplete>
                                                </ValidationProvider>
                                            </v-col>
                                            <v-col cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                                <ValidationProvider v-slot="{errors}" name="Cocina" rules="required">
                                                    <v-autocomplete
                                                        outlined
                                                        label="Cocina"
                                                        :items="cocinas"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        v-model="cocina_id"
                                                        required
                                                        :error-messages="errors"
                                                        ></v-autocomplete>
                                                </ValidationProvider>
                                            </v-col>
                                        </template>
                                        <v-col v-else-if="accion === 'update'" cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                                <ValidationProvider v-slot="{errors}" name="Cocina" rules="required">
                                                    <v-text-field
                                                        outlined
                                                        label="Cocina"
                                                        v-model="guiso.cocina_name"
                                                        required
                                                        readonly
                                                        :error-messages="errors"
                                                        ></v-text-field>
                                                </ValidationProvider>
                                            </v-col>
                                        <v-col cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                            <ValidationProvider v-slot="{errors}" name="Nombre" rules="required">
                                                <v-text-field
                                                    outlined
                                                    autofocus
                                                    label="Nombre"
                                                    v-model="guiso.nombre"
                                                    required
                                                    :error-messages="errors"></v-text-field>
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                            <v-autocomplete
                                                outlined
                                                label="Tipo"
                                                :items="tipo"
                                                item-text="nombre"
                                                item-value="valor"
                                                v-model="guiso.tipo"></v-autocomplete>
                                        </v-col>
                                        <v-col v-if="guiso.tipo !== 'fijo'"  cols="6" xs="6" md="6" lg="6" xl="6" class="py-0">
                                            <date-picker
                                                outlined
                                                rules="required"
                                                label="Fecha"
                                                :valorDefecto="guiso.fecha"
                                                v-model="guiso.fecha"
                                                placeholder="dd/mm/aaaa"
                                                ref="Fecha"></date-picker>
                                        </v-col>
                                        <v-col cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                            <money-validate
                                                rules="required"
                                                outlined
                                                label="Precio empleado"
                                                class="pa-0 ma-0"
                                                prefix="$"
                                                v-model="guiso.precio"
                                                :options="options"></money-validate>
                                        </v-col>
                                        <v-col cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                            <money-validate
                                                rules="required"
                                                outlined
                                                label="Precio empresa"
                                                class="pa-0 ma-0"
                                                prefix="$"
                                                v-model="guiso.precio_empresa"
                                                :options="options"></money-validate>
                                        </v-col>
                                        <v-col cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                            <v-textarea
                                            outlined
                                            label="Descripción"
                                            no-resize
                                            rows="2"
                                            v-model="guiso.descripcion"></v-textarea>
                                        </v-col>
                                        <v-col cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                            <v-file-input
                                                outlined
                                                label="Seleccionar imagen"
                                                prepend-icon=""
                                                accept="image/*"
                                                v-model="archivo"
                                                append-icon="attach_file"
                                                id="fileDocument"
                                                @click:append="open"
                                            ></v-file-input>
                                        </v-col>
                                        <v-col cols="12" xs="12" md="12" lg="12" xl="12" class="py-0">
                                           <v-img
                                            min-height="200"
                                            max-height="250"
                                            max-width="250"
                                            lazy-src="/static/modal/comidas/platillo_default.png"
                                            :src="imageUrl"
                                            ></v-img>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions class="d-flex justify-end card_accion">
                                <v-btn class="btnCerrar elevation-0" @click="cerrar()" :disabled="loading_guardar">Cancelar</v-btn>
                                <v-btn class="btnGuardar elevation-0" @click="guardar()" :loading="loading_guardar" :disabled="invalid">Guardar</v-btn>
                            </v-card-actions>
                        </ValidationObserver>
                    </v-card>
                </perfect-scrollbar>
            </v-dialog>
        </template>
    </div>
</template>

<script>
import Datatable from '@/components/datatable/Datatable'
import VuetifyDatePicker from '@/components/VuetifyDatePicker'
import VuetifyMoneyValidate from '@/components/VuetifyMoneyValidate'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import PerfectScrollbar from 'perfect-scrollbar'
import clientesApi from '@/api/clientes'
import empresasApi from '@/api/empresas'
import cocinasApi from '@/api/cocinas'
import guisosApi from '@/api/guisos'
import Notify from '@/plugins/notify'

import getUrlImg from '@/plugins/Urlimagen'

    export default {
        components:{
            'data-table':Datatable,
            'date-picker':VuetifyDatePicker,
            'money-validate':VuetifyMoneyValidate,
            ValidationObserver,
            ValidationProvider,
        },
        data(){
            return{
                url:'comida-guiso/find',
                columns:[
                    {
                        label:'Nombre',
                        name:'nombre',
                        filterable:true
                    },
                    {
                        label:'Cocina',
                        name:'descripcion',
                        filterable:false
                    },
                    {
                        label:'Fecha',
                        name:'fecha',
                        filterable:true,
                    },
                    {
                        label:'Tipo',
                        name:'tipo',
                        filterable:true,
                    },
                    {
                        label:'Opciones',
                        name:'opciones',
                        filterable:false,
                        align:'center'
                    },
                ],
                titulo_modal:'',
                titulo_modalLayout:'',
                acccion_layout:'',
                imagen:'/static/modal/clienteCreate.svg',
                cliente_id:null,
                empresa_id:null,
                sucursal_id:null,
                cocina_id:null,
                nombre_guiso:'',
                modal_layout:false,
                modal_replica:false,
                archivo_layout:null,
                clientes:[],
                empresas:[],
                cocinas:[],
                baseUrl:getUrlImg.getURL(),
                imageUrl:'',
                guiso:{
                    id:null,
                    nombre:'',
                    descripcion:'',
                    tipo:'',
                    fecha:null,
                    precio:'',
                    precio_empresa:'',
                    cocina_name:''
                },
                replica:{
                    guiso_id:null,
                    fecha: null
                },
                tipo:[
                    {
                        nombre:'Diario',
                        valor: 'diario'
                    },
                    {
                        nombre:'Fijo',
                        valor:'fijo'
                    }
                ],
                filtroTipoArr:['Todos','Diario','Fijo'],
                filtroTipo:null,
                filters:{
                    activo          :true,
                    paginate        :true,
                    order_by        :'fecha',
                    tipo            :null,
                    empresa_id      :null,
                    cliente_id      :null,
                    sucursal_id     :null,
                    cocina_id       :null,
                    nombre          :'  ',
                    fecha_min       :null,
                    fecha_max       :null,
                },
                options:{
                    locale:'es-Mx',
                    prefix:'$',
                    suffix:'',
                    lenght:11,
                    precision:2
                },
                loading_guardar:false,
                accion:'',
                modal:false,
                datosLogin:'',
                rol:'',
                archivo:undefined,
                params:{activo:true,paginate:false,order:'asc'}
            }
        },
        watch:{
            cliente_id:function(newVal){
                if(newVal != null){
                    this.getEmpresas(newVal)
                }
            },
            empresa_id:function(newVal){
                if(newVal != null && this.rol != 'admin-sucursal'){
                    this.getCocinas(newVal)
                }
            },
            archivo:function(newVal){
                //console.log(newVal);
                if(newVal != null && val != undefined){
                    //console.log(typeof newVal);
                    this.onFileChange(newVal)
                }else{
                    this.imageUrl = '/static/modal/comidas/platillo_default.png'
                }
            }
        },
        methods:{
            listar(){
                this.datosLogin = this.$session.get('usuario')
                this.rol = this.datosLogin.rol.name
                
                if(this.rol == 'admin'){
                    this.cliente_id = this.datosLogin.cliente_id
                    this.filters.cliente_id = this.datosLogin.cliente_id
                }else if(this.rol == 'admin-empresa'){
                    this.cliente_id = this.datosLogin.cliente_id
                    this.empresa_id = this.datosLogin.empresa_id
                    this.filters.empresa_id = this.datosLogin.empresa_id
                    
                }else if(this.rol == 'admin-sucursal'){
                    this.cliente_id = this.datosLogin.cliente_id
                    this.empresa_id = this.datosLogin.empresa_id
                    this.sucursal_id = this.datosLogin.sucursal_id
                    this.filters.sucursal_id = this.datosLogin.sucursal_id
                }
            },
            async loadModalData(){
                await this.reset()

                if(this.rol == 'root'){
                    this.getClientes()
                }else if(this.rol == 'admin'){
                    this.getEmpresas(this.cliente_id)
                }else if(this.rol == 'admin-empresa'){
                    this.getCocinas(this.empresa_id)
                }else if(this.rol == 'admin-sucursal'){
                    this.getCocinas(this.sucursal_id)
                }
                else{
                    this.getCocinas(this.empresa_id)
                }
            },
            setFilters(){

                this.filters.cliente_id = this.cliente_id
                this.filters.empresa_id = this.empresa_id
                this.filters.cocina_id = this.cocina_id
                this.filters.sucursal_id = this.sucursal_id
                this.filters.nombre = this.nombre_guiso
                if(this.filtroTipo == 'Diario'){
                    this.filters.tipo = 'diario'
                }else if(this.filtroTipo == 'Fijo'){
                    this.filters.tipo = 'fijo'
                }else{
                    this.filters.tipo = null
                }

                console.log(this.filters);

                this.$refs.tableGuisos.getData()

            },
            async abrirModal(accion,item = null){
                this.errors.clear()
                await this.reset()
                this.accion = accion



                if(accion == 'add'){
                    this.modal = true
                    this.titulo_modal = 'Agregar nuevo platillo al menú'
                    this.imagen = '/static/modal/clienteCreate.svg' 
                    
                    if(this.rol == 'root'){
                        this.getClientes()
                    }else if(this.rol == 'admin'){
                        this.getEmpresas(this.cliente_id)
                    }else if(this.rol == 'admin-empresa'){
                        this.getCocinas(this.empresa_id)
                    }else if(this.rol == 'admin-sucursal'){
                        this.getCocinas(this.sucursal_id)
                    }
                    
                    
                }
                else if(accion == 'update'){
                    
                    this.modal = true
                    this.titulo_modal = 'Editar Guiso'
                    this.imagen = '/static/modal/clienteUpdate.svg'
                    this.guiso.id = item.id
                    this.cocina_id = item.cocina_id
                    this.guiso.nombre = item.nombre
                    this.guiso.descripcion = item.descripcion
                    this.guiso.fecha = item.fecha
                    this.guiso.precio = item.precio
                    this.guiso.precio_empresa = item.precio_empresa
                    this.guiso.tipo = item.tipo
                    this.guiso.cocina_name = item.cocina.nombre
                    this.imageUrl = `${this.baseUrl}${item.foto}`
                    //console.log(this.archivo);   
                }else if(accion =='duplicar'){
                    this.titulo_modal = 'Duplicar platillo'
                    this.replica.guiso_id = item.id
                    this.modal_replica = true

                    }
            },
            eliminarGuiso(id){
                Notify.Alert(
                    "Advertencia",
                    "¿Estás seguro que deseas eliminar el guiso actual?",
                    "Eliminar",()=>{
                        guisosApi.deleteGuiso(id).then(resp =>{
                            this.$refs.tableGuisos.getData()
                        }).catch(err =>{
                            if(typeof err.response.data.error === 'string'){
                                    Notify.ErrorToast(err.response.data.error)
                            }else{
                                let error = Object.values(err.response.data.error)
                                let leyenda = ``

                                for (var i = 0; i < error.length; i++){
                                    leyenda += `*` + error[i] + `\n`
                                }

                                Notify.ErrorToast(leyenda)
                            }                       
                        })
                    }
                )
            },
            duplicarGuiso(){
                this.$refs.formReplica.validate().then(result =>{
                    if(result){
                        this.loading_guardar = true

                        guisosApi.duplicarGuiso(this.replica).then(resp =>{
                            Notify.Success("Operación exitosa","El guiso se guardó satisfactoriamente")
                            this.$refs.tableGuisos.getData()
                            this.cerrar()
                        }).catch(err =>{
                                this.loading_guardar = false
                                if(typeof err.response.data.error === 'string'){
                                    Notify.ErrorToast(err.response.data.error)
                                }else{
                                    let error = Object.values(err.response.data.error)
                                    let leyenda = ``

                                    for (var i = 0; i < error.length; i++){
                                        leyenda += `*` + error[i] + `\n`
                                    }

                                    Notify.ErrorToast(leyenda)
                                }
                            })
                    }
                })
            },
            cerrar(){
                this.modal=false
                this.modal_layout = false
                this.modal_replica = false
                this.reset()
            },
            open(){
                document.getElementById('fileDocument').click()
            },
            guardar(){

                this.$refs.form.validate().then(result =>{
                    if(result){
                        this.loading_guardar = true

                        if(this.guiso.tipo === 'fijo'){
                            this.guiso.fecha = null
                        }

                        let formData = new FormData();

                        formData.append('cocina_id',this.cocina_id)
                        formData.append('nombre',this.guiso.nombre)
                        formData.append('descripcion',this.guiso.descripcion)
                        formData.append('tipo',this.guiso.tipo)
                        formData.append('fecha', this.guiso.fecha ? this.guiso.fecha : '')
                        formData.append('precio',this.guiso.precio)
                        formData.append('precio_empresa',this.guiso.precio_empresa)
                        if(this.archivo != null){
                            formData.append('foto', this.archivo);
                        }
                        if(this.accion === 'add'){
                            guisosApi.addGuiso(formData).then(resp =>{
                                this.$refs.tableGuisos.getData()
                                Notify.Success("Operación exitosa","El guiso se guardó satisfactoriamente")
                                this.cerrar()
                            }).catch(err =>{
                                this.loading_guardar = false
                                if(typeof err.response.data.error === 'string'){
                                    Notify.ErrorToast(err.response.data.error)
                                }else{
                                    let error = Object.values(err.response.data.error)
                                    let leyenda = ``

                                    for (var i = 0; i < error.length; i++){
                                        leyenda += `*` + error[i] + `\n`
                                    }

                                    Notify.ErrorToast(leyenda)
                                }
                            })
                        }
                        else if(this.accion === 'update'){
                            formData.append('id',this.guiso.id)
                            
                            guisosApi.updateGuiso(formData).then(resp =>{
                                this.$refs.tableGuisos.getData()
                                Notify.Success("Operación exitosa","El guiso se actualizó satisfactoriamente")
                                this.cerrar()
                            }).catch(err =>{
                                this.loading_guardar = false
                                if(typeof err.response.data.error === 'string'){
                                    Notify.ErrorToast(err.response.data.error)
                                }else{
                                    let error = Object.values(err.response.data.error)
                                    let leyenda = ``

                                    for (var i = 0; i < error.length; i++){
                                        leyenda += `*` + error[i] + `\n`
                                    }
                                    

                                    Notify.ErrorToast(leyenda)
                                }
                            })
                        }
                    }
                })
                
            },
            async reset(){

                this.loading_guardar = false 
                this.clientes = []
                this.empresas = []
                this.cocinas = []
                this.filters.fecha_max = null,
                this.filters.fecha_min = null,
                this.guiso = {
                    id:null,
                    nombre:'',
                    descripcion:'',
                    tipo:'',
                    fecha:'',
                    precio:'',
                    precio_empresa:'',
                    cocina_name:''
                },
                this.replica = {
                    guiso_id: null,
                    fecha: null
                }
                this.accion = ''
                if(this.rol == 'root'){
                    this.cliente_id = null
                    this.empresa_id = null
                }
                if(this.rol == 'admin'){
                    this.empresa_id = null
                }

                if(this.rol != 'admin-sucursal'){
                    this.sucursal_id = null
                }

                this.cocina_id = null
                this.archivo = undefined
                this.nombre_guiso = ''
                this.imageUrl = '/static/modal/comidas/platillo_default.png'
                this.acccion_layout = ''
                this.archivo_layout = null
                this.filtroTipo = null

                this.$nextTick(()=>{
                    if(this.$refs.form){
                        this.$refs.form.reset()
                    }
                    if(this.$refs.formLayout){
                        this.$refs.formLayout.reset()
                    }
                    if(this.$refs.formReplica){
                        this.$refs.formReplica.reset()
                    }
                })
            },
            getClientes(){
                clientesApi.getClientes(this.params).then(resp =>{
                    //console.log(resp.data);
                    this.clientes = resp.data
                }).catch(err =>{
                    console.log('ocurrio un error al cargar los clientes',err);
                })
            },
            getEmpresas(id){
                let params = {...this.params, cliente_id:id}
                //console.log(params);
                empresasApi.getEmpresas(params).then(resp=>{
                    this.empresas = resp.data
                    //console.log(resp.data);
                }).catch(err =>{
                    console.log('Ocurrio un error al cargar las empresas', err);
                })
            },
            getCocinas(id){
                let params = {...this.params,cliente_id:this.cliente_id,empresa_id:id}
                if(this.rol == 'admin-sucursal'){
                    params = {...this.params,cliente_id:this.cliente_id,empresa_id:this.empresa_id,sucursal_id:id};
                }
                cocinasApi.getCocinas(params).then(resp =>{
                    //console.log(resp.data);
                    this.cocinas = resp.data
                }).catch(err =>{
                    console.log('Ocurrio un error al cargar las cocinas',err);
                })
            },
            onFileChange(file){
                if(!file){
                    return
                }
                this.previewImage(file)
            },
            previewImage(file){
                const reader = new FileReader()

                reader.onload = e => {
                    this.imageUrl = e.target.result
                }

                reader.readAsDataURL(file)
            },
            modalLayout(accionLayout){
                this.errors.clear()
                this.reset()
                this.modal_layout = true
                this.acccion_layout = accionLayout

                if(this.rol == 'root'){
                    this.getClientes()
                }else if(this.rol == 'admin'){
                    this.getEmpresas(this.cliente_id)
                }

                if(accionLayout == 'importar'){
                    this.titulo_modalLayout = 'Importar layout de platillos'
                }
                else if(accionLayout == 'exportar'){
                    this.titulo_modalLayout = 'Descargar layout de platillos'
                }
            },

            async layoutGuiso(){
                this.$refs.formLayout.validate().then(success =>{
                    if(success){
                        this.loading_guardar = true

                        if(this.acccion_layout == 'importar'){
                            this.importarLayout()
                        }else if(this.acccion_layout == 'exportar'){
                            this.descargarLayout()
                        } 
                    }
                })
                
            },
            async importarLayout(){
                let formData = new FormData()

                if(this.rol == 'root'){
                    formData.append('cliente_id',this.cliente_id)
                    formData.append('empresa_id',this.empresa_id)
                }else if(this.rol == 'admin'){
                    formData.append('cliente_id',this.datosLogin.cliente_id)
                    formData.append('empresa_id',this.empresa_id)
                }else{
                    formData.append('cliente_id',this.datosLogin.cliente_id)
                    formData.append('empresa_id',this.datosLogin.empresa_id)
                }

                if(this.archivo_layout != null){
                    formData.append('archivo',this.archivo_layout)
                }

                guisosApi.importarLayout(formData).then(resp =>{
                    Notify.Success("Operación exitosa","Se subió el layout satisfactoriamente")
                    this.$refs.tableGuisos.getData()
                    this.cerrar()
                }).catch(err =>{
                    this.loading_guardar = false
                    if(typeof err.response.data.error === 'string'){
                        Notify.ErrorToast(err.response.data.error)
                    }else{
                        let error = Object.values(err.response.data.error)
                        let leyenda = ``

                        for (var i = 0; i < error.length; i++){
                            leyenda += `*` + error[i] + `\n`
                        }
                        

                        Notify.ErrorToast(leyenda)
                    }
                })

            },
            async descargarLayout(){
                const FileDownload = require("js-file-download")
                let self = this
                var today = new Date()
                let nombre = ''

                nombre = 'layout_platillos_' + today.getDate()
                        + '_' + (today.getMonth() + 1) + '_'
                        + today.getFullYear() + '.xlsx'
                
                let parametros = {
                    cliente_id: null,
                    empresa_id: null,
                    sucursal_id: null,
                }

                if(this.rol == 'root'){
                    parametros.cliente_id = this.cliente_id
                    parametros.empresa_id = this.empresa_id
                }else if(this.rol == 'admin'){
                    parametros.cliente_id = this.datosLogin.cliente_id
                    parametros.empresa_id = this.empresa_id  
                }else if(this.rol == 'admin-empresa'){
                    parametros.cliente_id = this.datosLogin.cliente_id
                    parametros.empresa_id = this.datosLogin.empresa_id
                }
                else if(this.rol == 'admin-sucursal'){
                    parametros.cliente_id = this.datosLogin.cliente_id
                    parametros.empresa_id = this.datosLogin.empresa_id
                    parametros.sucursal_id = this.datosLogin.sucursal_id
                }

                try{
                    
                    await guisosApi.descargarLayout(parametros).then(resp =>{
                        this.loading_guardar = false
                        FileDownload(resp.data,nombre)
                        this.cerrar()
                    }).catch(async (error)=>{
                        self.loading_guardar = false;
                        let errorString = error.response.data;
                        if (
                            error.request.responseType === 'blob' &&
                            error.response.data instanceof Blob &&
                            error.response.data.type &&
                            error.response.data.type.toLowerCase().indexOf('json') != -1
                        ){
                            errorString = JSON.parse(await error.response.data.text());

                            if(typeof errorString.error === 'string'){
                                Notify.ErrorToast(errorString.error);
                            }else{
                                let error = Object.values(errorString.error);
                                let leyenda = ``;

                                for (var i = 0; i < error.length; i++) {
                                    leyenda+= `* ` + error[i] + `\n`;
                                }
                                Notify.ErrorToast(leyenda);
                            }
                        }; 
                    })
                }catch(e){
                    this.loading_guardar = false
                    Notify.ErrorToast("Se produjo un error al realizar la petición.");
                }
            },
            dateFormat(fecha,tipo){
                if(!fecha) return
                let fecha2 = fecha.split('-')
                if(tipo == 'modal'){
                    return `${fecha2[2]}/${fecha2[1]}/${fecha2[0]}`
                }else{
                    return `${fecha2[2]} / ${fecha2[1]} / ${fecha2[0]}`
                }
            },
            redireccionar(){
                this.$router.push('/dashboard');
            },
        },
        created(){
            this.listar()
        }
    }
</script>

<style scoped>

 h2{
    font-family: 'Montserrat';
    font-size: 18px;
    font-weight: 600;
    line-height: 21.94px;
}

    .menuClassAcciones{
        /* box-shadow: none; */
        border-radius: 10px!important;
        margin-top:15px;
    }
    .btnAcciones {
        width: 135px !important;
        height: 42px !important;
        border-radius: 30px;
        text-transform: capitalize;
        background:#58C5D8 !important;
        color:#FFFFFF !important;
        font-family: "Montserrat" !important;
        font-style: normal !important;
        font-weight: 600 !important;
        font-size: 14px !important;
        line-height: 17px !important;
    }
    .btnAcciones:hover {
        width: 135px !important;
        height: 42px !important;
        border-radius: 30px;
        text-transform: capitalize;
        background:#58C5D8 !important;
        color:#FFFFFF !important;
        font-family: "Montserrat" !important;
        font-style: normal !important;
        font-weight: 600 !important;
        font-size: 14px !important;
        line-height: 17px !important;
        box-shadow: 0px 5px 8px rgba(26, 30, 66, 0.2);
        -webkit-transform: translatey(-1px);
        transform: translatey(-1px);
    }
    .btnAccionesContenedor {
        width: 300px;
        height: auto;
        padding-top: 10px;
        padding-bottom: 10px;
        background-color: #FFF;
    }
    div.btnAccionesTitulo {
        padding-left: 30px;
        padding-right: 30px;
    }
    div.btnAccionesTitulo span {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 18px;
        text-align: left;
        color: #1E2245;
    }
    div.btnAccionesItem {
        width: 100%;
        cursor: pointer;
        outline: 0;
        padding-left: 30px;
        padding-right: 30px;
    }
    div.btnAccionesItem span {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        text-align: left;
        color: #828282;
    }
    div.btnAccionesItem:hover {
        background: #F6F6F8;
    }

</style>